export default function LoadingSpinner({ size = 'md', className = '' }) {
  const sizeClass = {
    sm: 'h-5 w-5 border-2',
    md: 'h-10 w-10 border-[3px]',
    lg: 'h-14 w-14 border-4',
  }[size]

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`${sizeClass} animate-spin rounded-full border-border border-t-primary border-r-secondary`}
        role="status"
        aria-label="Loading"
      />
    </div>
  )
}
